import { render } from "./PrivacyStatements.vue?vue&type=template&id=724e9f48&scoped=true"
import script from "./PrivacyStatements.vue?vue&type=script&lang=js"
export * from "./PrivacyStatements.vue?vue&type=script&lang=js"

import "./PrivacyStatements.vue?vue&type=style&index=0&id=724e9f48&scoped=true&lang=scss"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724e9f48"]])

export default __exports__